<template lang="pug">
  b-container
    .header.mb-2.mt-0
      .header-body
        h6.header-pretitle
          | Referencias
    b-form-row.align-items-end.mt-3.mb-4
      b-col
        b-form-group(label="Seleccionar cuenta:")
          treeselect(:options="parsed_accounts", placeholder="-- Seleccionar cuenta --", v-model="msn_external_id", v-bind="treeselect_options", :clearable="false")
      b-col(cols="auto")
        b-spinner.mr-3(variant="primary", v-if="loading", small)
        b-button(variant="primary", @click="reference_modal = !reference_modal", :disabled="!msn_external_id") Crear referencia
    reference(v-for="ref in references" :key="ref.reference_id", v-bind="ref", :msn_external_id="msn_external_id", @ref:update="updateReference(ref.reference_id, $event)", @ref:destroy="destroyReference(ref.reference_id)")
    b-modal(v-model="reference_modal", ok-title="Crear", ok-variant="primary", cancel-title="Cancelar", title="Crear Referencia", @ok="createReference")
      b-form
        b-form-group(label="Nombre")
          b-form-input(placeholder="Nombre", v-model.trim="new_reference_name", required, :state="!!new_reference_name.length ? null : (validated ? false : null)")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import Reference from '@/components/Reference.vue'
import treeselectOptions from '@/data/treeselect-options'
const flowController = createNamespacedHelpers('flow')
const userAttributeController = createNamespacedHelpers('user_attribute')
const referenceController = createNamespacedHelpers('reference')

export default {
  data () {
    return {
      treeselect_options: treeselectOptions,
      loading: false,
      accounts: [],
      msn_external_id: null,
      reference_modal: false,
      new_reference_name: '',
      validated: false,
    }
  },
  computed: {
    ...flowController.mapState({
      flows: state => state.flows
    }),
    ...userAttributeController.mapState({
      user_attributes: state => state.user_attributes
    }),
    ...referenceController.mapState({
      references: state => state.references
    }),
    parsed_accounts () {
      return this.accounts.map(a => {
        return {
          id: a.external_id,
          label: a.name
        }
      })
    },
  },
  methods: {
    ...mapActions(['platform/get', 'user_attribute/all', 'flow/all', 'reference/all', 'reference/create', 'reference/update', 'reference/destroy']),
    getMessengerAccounts () {
      let self = this

      this['platform/get']({
        account_id: self.$route.params.account_id,
        platform_id: 'messenger',
        callback: res => {
          if (res.error) {
            self.$message.warning(res.error)
          } else {
            self.accounts = res.resource.slice()
            if(self.accounts.length && self.accounts[0].subscribed) {
              self.msn_external_id = res.resource[0].external_id
            } else {
              self.showNoBMessagingData()
            }
          }
        }
      })
    },
    showNoBMessagingData () {
      this.$bvModal.msgBoxConfirm('Puedes conectar una cuenta de Messenger en la sección de configuración. ¿Deseas hacerlo ahora?', {
        title: 'No tienes cuentas de Messenger',
        okVariant: 'success',
        okTitle: 'Ir a configuración',
        cancelTitle: 'Cerrar'
      })
        .then(value => {
          if (value == true) {
            this.$router.push({name: 'Settings'}).catch(()=>{});
          }
        })
        .catch(err => {
          // An error occurred
        })
    },
    getFlows () {
      let self = this

      this['flow/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.warning(res.error)
          }
        }
      })
    },
    getUserAttributes () {
      let self = this

      this['user_attribute/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.warning(res.error)
          } else {
            self.getReferences()
          }
        }
      })
    },
    getReferences () {
      let self = this
      this['reference/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.warning(res.error)
          }
        }
      })
    },
    createReference (modal) {
      modal.preventDefault()
      if(!this.new_reference_name.length) {
        this.validated = true
        return
      }

      let self = this
      this.loading = true

      this['reference/create']({
        account_id: self.$route.params.account_id,
        text: self.new_reference_name,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.warning(res.error)
          } else {
            self.reference_modal = false
            self.$message.success('Referencia creada')
          }
        }
      })
    },
    updateReference (reference_id, data)  {
      let self = this
      this.loading = true

      this['reference/update']({
        account_id: self.$route.params.account_id,
        reference_id: reference_id,
        ...data,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.warning(res.error)
          } else {
            self.$message.success('Referencia actualizada')
            let ref = self.references.find(r => r.reference_id == reference_id)
            for (let key in data) {
              try {
                ref[key] = data[key]
              } catch (e) { console.error(e.message) }
            }
          }
        }
      })
    },
    destroyReference (reference_id)  {
      var self = this

      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar esta referencia?`, {
        title: 'Eliminar referencia',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      })
      .then(value => {
        if (value == true) {
          self.loading = true
          self['reference/destroy']({
            account_id: self.$route.params.account_id,
            reference_id: reference_id,
            callback: res => {
              self.loading = false
              if (res.error) {
                self.$message.warning(res.error)
              }
            }
          })
        }
      })
      .catch(err => {
        // An error occurred
      })
    },
  },
  mounted () {
    this.getMessengerAccounts()
    this.getFlows()
    this.getUserAttributes()
  },
  watch: {
    reference_modal (val) {
      this.new_reference_name = ''
    }
  },
  components: { Reference }
}
</script>

<style lang="scss" scoped>
</style>
